import React from 'react';
import styles from './Iframe.module.css';

type TIframeProps = {
    $isFullScreen: boolean;
} & React.IframeHTMLAttributes<HTMLIFrameElement>;

export const Iframe = React.forwardRef<HTMLIFrameElement, TIframeProps>(({ $isFullScreen, className, title = 'Embedded content', ...rest }, ref) => {
    const classNames = [styles.iframe, $isFullScreen && styles.iframeFullScreen, className].filter(Boolean).join(' ');
    return <iframe ref={ref} title={title} className={classNames} {...rest} />;
});
